// extracted by mini-css-extract-plugin
export var container = "_5v-1";
export var editor = "_5v-2";
export var resizable = "_5v-3";
export var wrapper = "_5v-0";